/**
 * Sticky Product Form Image Sync
 * Syncs the sticky product form image with the currently selected variant
 */

(function() {
  'use strict';

  /**
   * Clone the active/visible product image from the main gallery to sticky form
   */
  function syncImageFromMainGallery() {
    const stickyMediaContainer = document.querySelector('.js-product-sticky-info-media');

    if (!stickyMediaContainer) {
      return;
    }

    // Find the currently active/visible product image in the main gallery
    // Try multiple selectors to find the active image
    let activeImage = document.querySelector('.js-product-slideshow-container .is-active img');

    if (!activeImage) {
      // Fallback: try to find the first visible media item
      activeImage = document.querySelector('.js-product-slideshow-container .js-product-media-item img');
    }

    if (!activeImage) {
      // Fallback: try carousel active item
      activeImage = document.querySelector('.product-slideshow img');
    }

    if (!activeImage) {
      console.warn('[Sticky Image Sync] No active product image found');
      return;
    }

    // Find or create img element in sticky container
    let stickyImg = stickyMediaContainer.querySelector('img');

    if (!stickyImg) {
      stickyImg = document.createElement('img');
      stickyImg.className = 'h-100 w-100 of-cover';
      stickyImg.loading = 'lazy';
      stickyMediaContainer.appendChild(stickyImg);
    }

    // Copy image attributes from active gallery image
    stickyImg.src = activeImage.src;
    stickyImg.srcset = activeImage.srcset || '';
    stickyImg.sizes = activeImage.sizes || '(min-width: 750px) 120px, 100px';
    stickyImg.alt = activeImage.alt || 'Product image';
  }

  /**
   * Update sticky form variant text from selected variant options
   */
  function updateStickyVariantText() {
    const variantTextElement = document.querySelector('.js-product-sticky-info-variant');

    if (!variantTextElement) {
      return;
    }

    // Find all selected variant option values
    const selectedOptions = [];

    // Try radio buttons first
    const selectedRadios = document.querySelectorAll('.js-variant-radio-item:checked');
    selectedRadios.forEach(radio => {
      const value = radio.value;
      if (value && value !== 'Default Title') {
        selectedOptions.push(value);
      }
    });

    // If no radios, try select dropdowns
    if (selectedOptions.length === 0) {
      const selects = document.querySelectorAll('select[name^="options"]');
      selects.forEach(select => {
        const value = select.value;
        if (value && value !== 'Default Title') {
          selectedOptions.push(value);
        }
      });
    }

    // Update the text
    variantTextElement.textContent = selectedOptions.join(' / ');
  }

  /**
   * Handle any change that might affect the displayed image
   */
  function handleChange() {
    // Small delay to allow the main gallery to update first
    setTimeout(() => {
      syncImageFromMainGallery();
      updateStickyVariantText();
    }, 100);
  }

  /**
   * Initialize sticky image sync
   */
  function init() {
    // Set initial image immediately
    syncImageFromMainGallery();
    updateStickyVariantText();

    // Listen for variant input changes
    const variantInputs = document.querySelectorAll('input[name="id"]');
    variantInputs.forEach(input => {
      // Watch for value attribute changes
      const observer = new MutationObserver(handleChange);
      observer.observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Also listen for change events
      input.addEventListener('change', handleChange);
    });

    // Listen for variant radio/select changes
    const variantRadios = document.querySelectorAll('.js-variant-radio-item');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', handleChange);
    });

    const variantSelects = document.querySelectorAll('select[name^="options"]');
    variantSelects.forEach(select => {
      select.addEventListener('change', handleChange);
    });

    // Listen for carousel/slideshow changes (when user clicks thumbnails)
    const productSlideshow = document.querySelector('.js-product-slideshow-container');
    if (productSlideshow) {
      const slideshowObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Check if the active class changed on media items
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('is-active')) {
              syncImageFromMainGallery();
            }
          }
        });
      });

      // Observe all media items for class changes
      const mediaItems = productSlideshow.querySelectorAll('.js-product-media-item');
      mediaItems.forEach(item => {
        slideshowObserver.observe(item, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /**
   * Re-initialize for Shopify theme editor
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(init, 100);
    });
  }

})();
